import EmptyState from '../../../components/elements/EmptyState';
import lockedStatisticsImage from '../../../images/locked-statistics.png';
import premiumStatisticsImage from '../../../images/premium-statistics.png';
import { LINK_CLICKS_ACCESS_STATUSES } from '../../../redux/slices/mePageData';
import { useTranslation } from 'react-i18next';
import { LINK_CLICKS_TAB } from './MePageTabs';

const PAYMENT_URL = 'https://admin.me-page.com/payment';

const ACCESS_STATE_CONTENT = {
  [LINK_CLICKS_ACCESS_STATUSES.LOCKED]: {
    image: lockedStatisticsImage,
    titleKey: 'linkClicks.lockedTitle',
    descriptionKey: 'linkClicks.lockedDescription',
    actionLabelKey: 'linkClicks.renewPremium'
  },
  [LINK_CLICKS_ACCESS_STATUSES.PREMIUM_REQUIRED]: {
    image: premiumStatisticsImage,
    titleKey: 'linkClicks.premiumTitle',
    descriptionKey: 'linkClicks.premiumDescription',
    actionLabelKey: 'linkClicks.upgradePremium',
    secondaryActionLabelKey: 'linkClicks.backToStatistics'
  }
};

const LinkClicksAccessState = ({ status, onBackToStatistics }) => {
  const { t } = useTranslation();
  const content = ACCESS_STATE_CONTENT[status];

  if (!content) return null;

  return (
    <div
      id={`${LINK_CLICKS_TAB}-panel`}
      role="tabpanel"
      aria-labelledby={`${LINK_CLICKS_TAB}-tab`}
    >
      <EmptyState
        image={content.image}
        title={t(content.titleKey)}
        description={t(content.descriptionKey)}
        actionLabel={t(content.actionLabelKey)}
        secondaryActionLabel={
          content.secondaryActionLabelKey
            ? t(content.secondaryActionLabelKey)
            : undefined
        }
        actionHref={PAYMENT_URL}
        actionVariant="orange"
        onSecondaryAction={onBackToStatistics}
        className="link-clicks-access-state"
      />
    </div>
  );
};

export default LinkClicksAccessState;
